import React, {Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {recordProxy} from '../../util';

export default function HelpService() {
    const history = useHistory();
    const jump = () => {
        const routerPath = '/help';
        recordProxy('newAttest', 'click', routerPath.replace('/', ''));
        routerPath && history.push(routerPath);
    };
    return (
        <Fragment>
            <div className="help-service">
                <p className="service-title help-service-title">常见问题</p>
                <div className="help-content">
                    <div className="help-service-list" onClick={jump}>
                        <span>百度企业号码认证是什么？</span>
                        <span className="arrow" ></span>
                    </div>
                    <div className="help-service-list" onClick={jump}>
                        <span>为什么要做企业号码认证？</span>
                        <span className="arrow" ></span>
                    </div>
                    <div className="help-service-list" onClick={jump}>
                        <span>如何认证企业电话号码？</span>
                        <span className="arrow" ></span>
                    </div>
                    <div className="help-service-list" onClick={jump}>
                        <span>提交联系信息后，什么时候会和我联系？</span>
                        <span className="arrow" ></span>
                    </div>
                    <div className="help-service-list" onClick={jump}>
                        <span>企业号码认证如何收费？</span>
                        <span className="arrow" ></span>
                    </div>
                    <button className="more-help" onClick={jump}>更多问题</button>
                </div>
            </div>
        </Fragment>
    );
}
